import * as Yup from 'yup'
import moment from 'moment'

export const AssignToEntryUserAndSendValidationSchema = Yup.object().shape({
  selectedSendTo: Yup.object().nullable().required('You must select a Send To option.'),
  assignUser: Yup.object().nullable(),
  dueDate: Yup.string()
    .nullable()
    .transform((value, originalValue) => {
      return originalValue === '' ? null : value
    })
    .notRequired()
    .test(
      'is-not-past',
      'Due Date cannot be in the past',
      (value: string | null | undefined) => {
        if (!value) return true
        const parsed = moment(value, 'YYYY-MM-DD', true)
        return parsed.isSameOrAfter(moment(), 'day')
      }
    )
    .test('is-valid-date', 'Due Date must be a valid date', () => {
      const dateInput = document.getElementById(
        'assignDueDate'
      ) as HTMLInputElement | null

      if (dateInput && dateInput.value === '') {
        if (dateInput.validity.badInput) {
          return false
        }
      } else {
        return true
      }

      return true
    }),
  comments: Yup.string().when('requireComment', {
    is: false,
    then: (schema: any) => schema.notRequired(),
    otherwise: (schema: any) => schema.required('Comments are required'),
  }),
  pendDate: Yup.string()
    .nullable()
    .transform((value, originalValue) => {
      return originalValue === '' ? null : value
    })
    .test(
      'pend-date-required-with-note',
      'Pend date is required when a pend note is entered',
      function (value) {
        return !this.parent.pendNote || !!value
      }
    )
    .test(
      'is-not-past',
      'Pend date cannot be in the past',
      (value: string | null | undefined) => {
        if (!value) return true
        const parsed = moment(value, 'YYYY-MM-DD', true)
        return parsed.isSameOrAfter(moment(), 'day')
      }
    ),
  pendNote: Yup.string().test(
    'pend-note-required-with-date',
    'Pend note is required when a pend date is entered',
    function (value) {
      return !this.parent.pendDate || !!value
    }
  ),
})
